import { render, staticRenderFns } from "./base_create.vue?vue&type=template&id=d6f07d8e&"
import script from "./base_create.vue?vue&type=script&lang=js&"
export * from "./base_create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports